import styled from 'styled-components';

export const StyledLabelContent = styled.div`
  margin-top: 5px;
`;